export const GET_DRUGS = 'GET_DRUGS';
export const GET_DRUGS_SUCCESS = 'GET_DRUGS_SUCCESS';

export const getDrugsAction = () => ({
        type: GET_DRUGS,
    }
);